import {MaxiDingConfig} from "../configuration/configurations";

export const sendMessage = (clientName, clientEmail, messageContent) => {
    const requestBody = JSON.stringify({
        clientName,
        clientEmail,
        messageContent,
    });
    return fetch(MaxiDingConfig.messageUrl, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: requestBody,
    });
}

export const queryMessageReply = (msgId) => {
    const requestUrl = MaxiDingConfig.messageUrl + '/' + msgId;
    return fetch(requestUrl, {
        method: 'GET',
    });
}